import { MasterInstance } from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  MasterApiMenuListsFindPostRequest,
  MasterApiMenuListsGetRequest,
  MasterApiMenuListsMenuListIdDeleteRequest,
  MasterApiMenuListsMenuListIdPutRequest,
  MasterApiMenuListsPostRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const menuList = createQueryKeys("menuLists", {
  all: null,
  get: (params: MasterApiMenuListsGetRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // 권한 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => MasterInstance.menuListsGet(queryParams),
    };
  },
  find: (params: MasterApiMenuListsFindPostRequest) => {
    const query = { ...params };
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }
    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => MasterInstance.menuListsFindPost(query),
    };
  },
});

export const mutateMenuList = {
  create: (params: MasterApiMenuListsPostRequest) => ({
    mutationKey: [params.menuListsGetRequest],
    mutationFn: () => MasterInstance.menuListsPost(params),
  }),
  update: (params: MasterApiMenuListsMenuListIdPutRequest) => ({
    mutationKey: [params.menuListsGetRequest, params.menuListId],
    mutationFn: () => MasterInstance.menuListsMenuListIdPut(params),
  }),
  delete: (params: MasterApiMenuListsMenuListIdDeleteRequest) => ({
    mutationKey: [params.menuListId],
    mutationFn: () => MasterInstance.menuListsMenuListIdDelete(params),
  }),
};
